import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import classNames from "classnames";

import SquareCheck from "./SquareCheck";

FnrCheckbox.propTypes = {
  on: PropTypes.bool,
  toggleOn: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  checkboxSide: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  checkColor: PropTypes.string,
  center: PropTypes.bool,
  checkboxSize: PropTypes.number,
};

export default function FnrCheckbox({
  children,
  on,
  toggleOn,
  disabled = false,
  loading = false,
  checkboxSide = "left",
  id,
  color,
  checkColor,
  checkboxSize,
  center,
  ...props
}) {
  const onClass = classNames({ on, disabled });

  return (
    <Outside center={center}>
      <Wrapper
        data-cy="fnrCheckbox"
        onClick={disabled || loading ? null : toggleOn}
        // onMouseDown={disabled || loading ? null : toggleOn}
        // onTouchStart={disabled || loading ? null : toggleOn}
        className={onClass}
        disabled={loading}
        {...props}
      >
        <CheckHolder order={checkboxSide === "left" ? 1 : 2}>
          <SquareCheck
            checkboxSize={checkboxSize}
            checked={on}
            role="checkbox"
            ariaChecked={on}
            ariaLabelledBy={id}
            color={color}
            checkColor={checkColor}
            loading={loading}
            className={onClass}
          />
        </CheckHolder>
        <Content id={id} order={checkboxSide === "left" ? 2 : 1}>
          {children}
        </Content>
      </Wrapper>
    </Outside>
  );
}

const Outside = styled.div`
  display: flex;
  ${(p) => p.center && `justify-content: center;`}
`;

const Wrapper = styled.div`
  /* padding: 12px 0; */
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: opacity 0.2s;
  box-sizing: border-box;
  &.disabled {
    opacity: 0.8;
    cursor: not-allowed;
  }

  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
`;

const Content = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  order: ${(props) => props.order};
  /* padding-left: 48px; */
  font-size: 15px;
  font-weight: 400;
`;
const CheckHolder = styled.div`
  /* margin-left: 12px; */
  flex-shrink: 0;
  flex-grow: 0;
  order: ${(props) => props.order};
  /* margin-right: 5px; */

  @media screen and (max-width: 480px) {
    align-self: flex-start;
    margin-top: 2px;
  }
`;

// const FnrCheckboxIconStyle = styled.div`
//   font-size: 24px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   width: 40px;
//   align-self: stretch;
//   height: 100%;
//   left: 0;
//   position: absolute;
// `;
// export const FnrCheckboxText = styled.div`
//   width: 100%;
//   font-weight: 400;
// `;
// export const FnrCheckboxSubtext = styled.div`
//   width: 100%;
//   font-size: 13px;
//   color: #384a5d;
//   margin-top: 2px;
//   line-height: 15px;
// `;

// export function FnrCheckboxIcon({ className, ...props }) {
//   return (
//     <FnrCheckboxIconStyle {...props}>
//       <div className={className} />
//     </FnrCheckboxIconStyle>
//   );
// }
